/** Tipo da tarefa do usuário; espelha `UserTaskType` do backend. */
export enum TaskType {
  EXPORT = 'EXPORT',
  AUTOMATIC_REPLENISHMENT = 'AUTOMATIC_REPLENISHMENT',
  AUTOMATIC_PICKLIST = 'AUTOMATIC_PICKLIST',
}
